module.exports = __webpack_public_path__ + "img/Picture16.0a1f189e.png";